exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LinkButtons1 .link-button{border-width:1px;border-style:solid}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/LinkButtons1/src/components/contents/LinkButtons1/LinkButtons1.s.scss"],"names":[],"mappings":"AAEA,2BAEI,iBAAiB,AACjB,kBAAmB,CACpB","file":"LinkButtons1.scss","sourcesContent":["@import '~scss/variables';\n\n.LinkButtons1 {\n  .link-button {\n    border-width: 1px;\n    border-style: solid;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/LinkButtons1/LinkButtons1.scss
// module id = 996
// module chunks = 118